import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Observer } from 'rxjs/Observer';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import Cookies from 'js-cookie';
import { timeout, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { BehaviorSubject } from 'rxjs';
import { CustomerDetails } from 'app/interfaces/sss-loan';

@Injectable()
export class OlapService {
  private headerState_loggedIn = new Subject<any>();
  private loanreview_currentId = new Subject<any>();
  private httpOptions = {};
  ajaxStatusObserver: Observer<any>;
  allowedGroupForBuyout = ['sss_fss', 'sss_ci', 'credit_group', 'sss_collection'];
  public isLoading: boolean = false;

  constructor(private http: HttpClient, private router: Router) {
      this.httpOptions = {
          withCredentials: true,
          headers: new HttpHeaders({
            'X-CSRFToken': this.getCookie('csrftoken')
          })
      };
  }

  private dependentsSource = new BehaviorSubject<any[]>([]);
  currentDependents = this.dependentsSource.asObservable();

  updateDependents(dependents: any[]) {
      this.dependentsSource.next(dependents);
  }

  setHeaderState(state: any) {
    console.log('set header invoked')
    this.headerState_loggedIn.next(state);
  }

  setLoanReviewId(id: any) {
    console.log('set review id: ' + id);
    this.loanreview_currentId.next(id);
  }

  getHeaderState(): Observable<any> {
    return this.headerState_loggedIn.asObservable();
  }

  getLoanReviewId(): Observable<any> {
    return this.loanreview_currentId.asObservable();
  }

  getLoanDocument(loanId: any, docType: string): Observable<any> {
      return this.http.get(environment.apiUrl +
                'document/?loan_id=' + loanId + '&doctype=' + docType,
                {
                    withCredentials: true,
                    headers: new HttpHeaders({
                      'X-CSRFToken': this.getCookie('csrftoken')
                    })
                });
  }

  getCookie(name) {
    return Cookies.get(name, {domain: environment.domain, path: environment.path});
  }

  getDateTime(dateStr: string, type?: string): string {
      const dateInfo = dateStr.split('T');
      const date = dateInfo[0];
      const time = dateInfo[1].substr(0, 5);
      return (type === 'date') ? date : date + ' ' + time;
  }

  sortByDateDesc(data: any[]): any[] {
      return data.sort((a, b) => {
          return new Date(b.loan_released_date).getTime() - new Date(a.loan_released_date).getTime();
      });
  }

  // START HERE - other_loans services
  getBuyoutLoans(filter: string): Observable<any> {
      return this.http.get(environment.apiUrl + 'otherloans/' + filter,
                  {
                      withCredentials: true,
                      headers: new HttpHeaders({
                        'X-CSRFToken': this.getCookie('csrftoken')
                      })
                  })
                  .map(resp => resp);
  }

  getBuyoutLoanDetails(loanId): Observable<any> {
      return this.http.get(environment.apiUrl + 'otherloans/' + loanId + '?category=BUYOUT_LOANS',
              {
                  withCredentials: true,
                  headers: new HttpHeaders({
                    'X-CSRFToken': this.getCookie('csrftoken')
                  })
              });
  }

  insertBuyoutDetails(data): Observable<any> {
      return this.http.post(environment.apiUrl + 'otherloans/', data,
                {
                    withCredentials: true,
                    headers: new HttpHeaders({
                      'X-CSRFToken': this.getCookie('csrftoken')
                    })
                });
  }

  changeStatusOtherLoans(loan_other_id, data: object): Observable<any> {
      return this.http.put(environment.apiUrl + 'otherloans/' + loan_other_id,
                data,
                {
                    withCredentials: true,
                    headers: new HttpHeaders({
                      'X-CSRFToken': this.getCookie('csrftoken')
                    })
                });
  }
  // END HERE - other_loans services

  createClientNLoan(data): Observable<any> {
    return this.http.post(environment.apiUrl + 'loan/incomplete/', data,
      {
        withCredentials: true,
        headers: new HttpHeaders({
          'X-CSRFToken': this.getCookie('csrftoken')
        })
      }
    )
  }

  postDependents(data: any): Observable<any> {
      return this.http.post(environment.apiUrl + 'client-dependents/', data, 
            {
              withCredentials: true,
              headers: new HttpHeaders({
                'X-CSRFToken': this.getCookie('csrftoken')
              })
            }
        );
  }

  getDependents(clientId, loanId): Observable<any> {
      const apiUrl = environment.apiUrl + 'client-dependents/';
      const params = new HttpParams()
          .set('client_id', clientId.toString())
          .set('loan_id', loanId.toString());
      return this.http.get(apiUrl, {
            params: params,
            withCredentials: true,
            headers: new HttpHeaders({
              'X-CSRFToken': this.getCookie('csrftoken')
            })
        });
  }

  submitLoanForCI(loan_id, data): Observable<any> {
    return this.http.post(environment.apiUrl + 'loan/for_ci/'+loan_id, data,
      {
        withCredentials: true,
        headers: new HttpHeaders({
          'X-CSRFToken': this.getCookie('csrftoken')
        })
      }
    )
  }

  submitLoanForProcessing(loan_id, data): Observable<any> {
    return this.http.post(environment.apiUrl + 'loan/for_processing/'+loan_id, data,
      {
        withCredentials: true,
        headers: new HttpHeaders({
          'X-CSRFToken': this.getCookie('csrftoken')
        })
      }
    )
  }

  createAddress(data): Observable<any>{
    return this.http.post(environment.apiUrl + 'address/', data,
      {
        withCredentials: true,
        headers: new HttpHeaders({
          'X-CSRFToken': this.getCookie('csrftoken')
        })
      }
    )
  }

  createOtherLoan(data): Observable<any>{
    return this.http.post(environment.apiUrl + 'otherloans/', data,
      {
        withCredentials: true,
        headers: new HttpHeaders({
          'X-CSRFToken': this.getCookie('csrftoken')
        })
      }
    )
  }

  createPensionInfo(data): Observable<any>{
    return this.http.post(environment.apiUrl + 'pension/', data,
      {
        withCredentials: true,
        headers: new HttpHeaders({
          'X-CSRFToken': this.getCookie('csrftoken')
        })
      }
    )
  }

  createBankInfo(data): Observable<any>{
    return this.http.post(environment.apiUrl + 'bank/', data,
      {
        withCredentials: true,
        headers: new HttpHeaders({
          'X-CSRFToken': this.getCookie('csrftoken')
        })
      }
    )
  }

  uploadKycDoc(data): Observable<any>{
    return this.http.post(environment.apiUrl + 'document/', data,
      {
        withCredentials: true,
        headers: new HttpHeaders({
          'X-CSRFToken': this.getCookie('csrftoken')
        })
      }
    )
  }

  removeKycDoc(kyc_id): Observable<any>{
    return this.http.delete(environment.apiUrl + 'document/' + kyc_id ,
      {
        withCredentials: true,
        headers: new HttpHeaders({
          'X-CSRFToken': this.getCookie('csrftoken')
        })
      }
    )
  }

   /* Method to convert Base64Data Url as Image Blob */
  dataURItoBlob(dataURI: string): Observable<Blob> {
    return Observable.create((observer: Observer<Blob>) => {
      let dataurl = dataURI.replace(/^data:image\/(png|jpe?g);base64,/, "");
      var byteString: string = atob(dataurl);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      let arrayBuffer: ArrayBuffer = new ArrayBuffer(byteString.length);
      let int8Array: Uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
      }
      let blob = new Blob([arrayBuffer], { type: mimeString });
      observer.next(blob);
      observer.complete();
    });
  }

  // START esignature service
  getOTP(data): Observable <any> {
    return this.http.post(environment.apiUrl + 'tools/esign/', data,
                {
                    withCredentials: true,
                    headers: new HttpHeaders({
                      'X-CSRFToken': this.getCookie('csrftoken')
                    })
                });
  }
  addEsignature(data): Observable<any> {
    console.log('access here accepted')
      return this.http.post(environment.apiUrl + 'tools/esign/', data,
                {
                    withCredentials: true,
                    headers: new HttpHeaders({
                      'X-CSRFToken': this.getCookie('csrftoken')
                    })
                });
  }
  downloadDocs(zip_name: string): Observable<any> {
      return this.http.get(environment.apiUrl + 'tools/esign/?zip='+zip_name,
              { 
                  responseType: 'blob',
                  withCredentials: true,
                  headers: new HttpHeaders({
                    'X-CSRFToken': this.getCookie('csrftoken')
                  })
              });
  }

  getRenewalOTP(data): Observable<any> {
    console.log(environment.apiUrl + 'renewals/')
    return this.http.post(environment.apiUrl + 'renewals/', data,
                {
                    withCredentials: true,
                    headers: new HttpHeaders({
                      'X-CSRFToken': this.getCookie('csrftoken')
                    })
                });
  }

  cancelAutomatedLoan(renewal_id, data): Observable<any> {
    return this.http.post(environment.apiUrl + 'cancel-automated-loan/' + renewal_id,
              data,
              {
                withCredentials: true,
                headers: new HttpHeaders({
                  'X-CSRFToken': this.getCookie('csrftoken')
                })
              });
  }
  resendOTP(data): Observable<any> {
    console.log(environment.apiUrl + 'renewals/')
    data = {
      ...data,
      method: 'resend-otp',
    };
    return this.http.post(environment.apiUrl + 'renewals/', data,
              {
                withCredentials: true,
                headers: new HttpHeaders({
                  'X-CSRFToken': this.getCookie('csrftoken')
                })
              });
  }
  downloadRenewalDocs(zip_name: string): Observable<any> {
    return this.http.get(environment.apiUrl + 'renewals/?zip='+zip_name,
            { 
                responseType: 'blob',
                withCredentials: true,
                headers: new HttpHeaders({
                  'X-CSRFToken': this.getCookie('csrftoken')
                })
            });
  }
  changeStatusRenewal(renewal_id, data: object): Observable<any> {
    return this.http.put(environment.apiUrl + 'renewals/' + renewal_id,
              data,
              {
                  withCredentials: true,
                  headers: new HttpHeaders({
                    'X-CSRFToken': this.getCookie('csrftoken')
                  })
              }); 
  }
  // END esignature service

  // Program Service
  getLoanPrograms(filter: string): Observable<any> {
    return this.http.get(environment.apiUrl + 'programs/',
                {
                    withCredentials: true,
                    headers: new HttpHeaders({
                      'X-CSRFToken': this.getCookie('csrftoken')
                    })
                })
                .map(resp => resp);
}
// End program Service

  assignLoanOfficerToMyself(data: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'credit/', data, {
        withCredentials: true,
        headers: new HttpHeaders({
          'X-CSRFToken': this.getCookie('csrftoken')
        })
    });
  }

  ping(data: any): Observable<any> {
    return this.http.get(environment.apiUrl + 'ping/?data=' + data,
              {
                  withCredentials: true,
                  headers: new HttpHeaders({
                    'X-CSRFToken': this.getCookie('csrftoken')
                  })
              });
  }

  checkConnectionStatus(data: any): Observable<any> {
    return this.http.get(environment.apiUrl + 'ping/?data=' + data,
              {
                  withCredentials: true,
                  headers: new HttpHeaders({
                    'X-CSRFToken': this.getCookie('csrftoken')
                  })
              })
              .pipe(
                  timeout(3000),
                  catchError(e => {
                      alert('No internet connection. Please check your internet connection and try again.');
                      return of(0);
                  })
              );
  }

    getBranches(): Observable<any> {
        return this.http.get<any[]>(environment.apiUrl + 'branches/',
                  {
                      withCredentials: true,
                      headers: new HttpHeaders({
                          'X-CSRFToken': this.getCookie('csrftoken')
                      })
                  });
    }

    updatePersonalDetails(customerDetails: CustomerDetails): Observable<any> {
        return this.http.put(environment.apiUrl + 'client-details/',
                  customerDetails,
                  {
                      withCredentials: true,
                      headers: new HttpHeaders({
                        'X-CSRFToken': this.getCookie('csrftoken')
                      })
                  });
    }

    convertPhoneToNum(phoneNumber: string): number {
        let result = null;
        if (phoneNumber.trim()) {
            const cleanedNumber = phoneNumber.replace(/\D/g, '');
            result = parseInt(cleanedNumber, 10);
        }
        return result;
    }

    getKYCDocumentStatus(loanId, clientID): Observable<any> {
      return this.http.get(environment.apiUrl + 'kyc-document-status/?loan_id='+loanId+'&client_id='+clientID,
              {
                  withCredentials: true,
                  headers: new HttpHeaders({
                    'X-CSRFToken': this.getCookie('csrftoken')
                  })
              });
    }

}



// WEBPACK FOOTER //
// /opt/sss_web/sss_web/src/app/service/olap-service.service.ts